import React from 'react'
import ContentLoader from 'react-content-loader'
import { ProductCardSkeleton } from '@sainsburys-tech/bolt'

const AlternativesSkeleton = ({ speed = 2, primaryColor = '#f3f3f3', secondaryColor = '#ecebeb' }) => (
  <div className='container'>
    <h2 className='h2'>
      <ContentLoader
        height={40}
        width={1170}
        speed={speed}
        backgroundColor={primaryColor}
        foregroundColor={secondaryColor}
        uniqueKey='alternatives-title'
      >
        <rect x='0' y='0' rx='2' ry='2' width='585' height='40' />
      </ContentLoader>
    </h2>
    {/* this is to make the skeleton work */}
    <div style={{ position: 'absolute', left: '-50000px' }}>
      <ProductCardSkeleton />
    </div>
    <div className='xs-row'>
      <div className='xs-12--none xs-row md-hidden'>
        {new Array(2).fill(undefined).map((_u, index) => (
          <div key={`${index}-skeleton-xs`} className='xs-12 sm-6 '>
            <ProductCardSkeleton />
          </div>
        ))}
      </div>
      <div className='xs-12--none xs-hidden md-row lg-hidden'>
        {new Array(3).fill(undefined).map((_u, index) => (
          <div key={`${index}-skeleton-md`} className='m4-4'>
            <ProductCardSkeleton />
          </div>
        ))}
      </div>
      <div className='xs-12--none xs-hidden lg-row'>
        {new Array(4).fill(undefined).map((_u, index) => (
          <div key={`${index}-skeleton-lg`} className='lg-3'>
            <ProductCardSkeleton />
          </div>
        ))}
      </div>
    </div>
  </div>
)
export default AlternativesSkeleton
